import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { createUserValidationForm } from "../../utils/validationSchema";
import TextField from "../Reusable/Form/TextInput";
import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/Form/ComboboxInput";
import USerComboboxInput from "../Reusable/Form/ComboboxInput/userCombobox";;
import Form from "../../layouts/Form";
import MultipleSelectField from "../Reusable/Form/MultipleSelectField";

const CreateMerchant = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createUserValidationForm),
  });
  const { handleCreate, isLoading } = props;


  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
        <USerComboboxInput
          url={APIS.USER}
          queryKey={"user"}
          register={register("user")}
          errors={errors?.user}
          name={"user"}
          label={"User"}
          setValue={setValue}
          placeholder={"Search user"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <TextField
          label={"PAN/VAT"}
          register={register("vat_pan")}
          errors={errors?.vat_pan}
        />
        <MultipleSelectField
          queryKey={"service-type"}
          label={"Service Type"}
          register={register("service_type")}
          watch={watch}
          setValue={setValue}
          url={APIS.SERVICE_TYPE}
          value={[]}
        />
        <MultipleSelectField
          label={"Product Type"}
          queryKey={"product-type"}
          register={register("product_type")}
          watch={watch}
          setValue={setValue}
          url={APIS.PRODUCT_TYPE}
          value={[]}
        />
        <MultipleSelectField
          label={"Service Branch"}
          queryKey={"service-branch"}
          register={register("service_branch")}
          watch={watch}
          setValue={setValue}
          url={APIS.BRANCH}
          value={[]}
        />
        <MultipleSelectField
          label={"Service City"}
          queryKey={"service-city"}
          register={register("service_city")}
          watch={watch}
          setValue={setValue}
          url={`${APIS.LOCATION}flat-location/`}
          value={[]}
          props={{
            level: 3
          }}
        />
        <ComboboxInput
          url={APIS.DELIVERY_CHARGE_TEMPLATE}
          props={{}}
          queryKey={"delivery-charge-template"}
          register={register("delivery_charge_template")}
          errors={errors?.delivery_charge_template}
          name={"delivery_charge_template"}
          label={"Rate Template"}
          setValue={setValue}
          placeholder={"Search Rate Template"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
      </div>
    </Form>
  );
};

export default CreateMerchant;